import { LUCIMARK_BRAND_THEME_COLOR } from '@lucimark/shared/constants/lucimark-brand-mark'

/** Brand charcoal boot / idle chrome background. */
export const PLAYER_BOOT_THEME_COLOR = LUCIMARK_BRAND_THEME_COLOR

/** Square boot frame — native cold-start / reduced-motion fallback. */
export const DEFAULT_BOOT_SPLASH_FRAME_URL = '/boot-splash-frame.png'
/** Transparent lockup for tenant custom logos / error fallback. */
export const DEFAULT_BOOT_LOCKUP_URL = '/boot-lockup.png'

/** Spinning Lucimark lockup (SMIL orbit) for `#app-loading` WebView cover. */
export const DEFAULT_BOOT_LOCKUP_ANIMATED_URL = '/lucimark-lockup-dark-animated.svg'

/** Full-frame splash SVGs (legacy boot / reduced-motion fallback). */
export const DEFAULT_BOOT_SPLASH_STATIC_URL = '/player-splash.svg'
export const DEFAULT_BOOT_SPLASH_ANIMATED_URL = '/player-splash-animated.svg'

/** Tenant custom logo raster fallback (legacy Android splash_logo parity). */
export const DEFAULT_BOOT_LOGO_URL = '/boot-logo.png'

export function resolveDefaultBootSplashUrl(): string {
  if (
    typeof window !== 'undefined'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return DEFAULT_BOOT_SPLASH_FRAME_URL
  }
  return DEFAULT_BOOT_LOCKUP_ANIMATED_URL
}

export function resolveDefaultBootSplashIsAnimated(): boolean {
  return resolveDefaultBootSplashUrl() === DEFAULT_BOOT_LOCKUP_ANIMATED_URL
}
